// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"c3531b95","325":"e2e6c263","516":"113da9b5","901":"1a6fa5f6","996":"f5bf3b63"}[chunkId] + ".css";
};